<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lieferscheine', 'suche', 'index']">
          <i class="fa fa-truck"></i>
          Lieferscheine
        </a>
      </li>
      @if (deliveryNoteId) {
        <li>
          <a [routerLink]="['/', 'lieferscheine', deliveryNoteId]">{{ deliveryNote?.number }}</a>
        </li>
        <li>
          <a>Bearbeiten</a>
        </li>
      } @else {
        <li>
          <a>Lieferschein erstellen</a>
        </li>
      }
    </ul>
  </div>
</div>
@if (isLoaded && wareHouses && countries) {
  <div class="page-content overflow-y-auto">
    <form
      class="page-sheet max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4"
      [formGroup]="deliveryNoteForm"
      (submit)="saveDeliveryNote()"
    >
      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <legend class="bm-fieldset-legend bm-card-title">Absender</legend>
          <hawk-address-auto-fill
            [countries]="countries"
            [wareHouses]="wareHouses"
            [customers]="senderCustomers"
            [technicians]="technicians"
            [loadingCustomers]="senderCustomersLoading"
            [loading]="senderLoading"
            [filteredStores]="senderStores"
            [formGroup]="addressesForm"
            prefix="sender_"
            [senderRecieverTypes]="senderRecieverTypes"
            (onAddressTypeChangeClicked)="onAddressTypeChange($event, 'sender_')"
            (onAddressChangeClicked)="onAddressChange($event, 'sender_')"
            (onChangeCustomerClicked)="onChangeCustomer($event, 'sender_')"
            (onFetchMoreStores)="onFetchMoreStores('sender_')"
            (onFetchMoreCustomers)="onFetchMoreCustomers('sender_')"
          />
          <hawk-address-form [formGroup]="deliveryNoteForm" prefix="sender" [countries]="countries" />
        </fieldset>
      </div>

      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <legend class="bm-fieldset-legend bm-card-title">Empfänger</legend>
          <hawk-address-auto-fill
            [countries]="countries"
            [wareHouses]="wareHouses"
            [customers]="recipientCustomers"
            [technicians]="technicians"
            [filteredStores]="recipientStores"
            [loadingCustomers]="recipientCustomersLoading"
            [loading]="recipientLoading"
            [formGroup]="addressesForm"
            prefix="recipient_"
            [senderRecieverTypes]="senderRecieverTypes"
            (onAddressTypeChangeClicked)="onAddressTypeChange($event, 'recipient_')"
            (onAddressChangeClicked)="onAddressChange($event, 'recipient_')"
            (onChangeCustomerClicked)="onChangeCustomer($event, 'recipient_')"
            (onFetchMoreStores)="onFetchMoreStores('recipient_')"
            (onFetchMoreCustomers)="onFetchMoreCustomers('recipient_')"
          />
          <hawk-address-form [formGroup]="deliveryNoteForm" prefix="recipient" [countries]="countries" />
        </fieldset>
      </div>

      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <legend class="bm-fieldset-legend bm-card-title">RMAs einscannen</legend>
          <div formGroupName="rma" class="bm-fieldset">
            @for (rma of rmas.controls; track $index; let i = $index) {
              <div class="bm-join w-full">
                <div class="w-full bm-input bm-join-item">
                  <span class="bm-label">RMA</span>
                  <input
                    class="w-full bm-inline"
                    #rmaInput
                    matInput
                    type="text"
                    [value]="setRmasDefaultValue && rma.value && rma.value.id > 0 ? rma.value.rma : ''"
                    placeholder="RMA"
                    (keydown.enter)="onRmaKeyDown($event, i)"
                  />
                </div>
                @if (rmas.controls.length > 1 && rmas.controls[i + 1] != null) {
                  <a (click)="onDeleteRma(i)" class="deleteRMA bm-join-item bm-btn">
                    <i class="fas fa-trash-alt"> </i>
                  </a>
                }
              </div>

              @if (rma.value && rma.value.id && rma.value.id > 0) {
                <div class="mb-2">
                  {{ rma.value.rma }}, {{ rma.value.template_description }}, {{ rma.value.product_category }},
                  {{ rma.value.vendor }}, {{ rma.value.serial_number }}
                  @switch (rma.value.location) {
                    @case ("SHIPPING") {
                      <span class="bm-badge bm-badge-error"> Im Versand </span>
                    }
                    @case ("CONSUMED") {
                      <span class="bm-badge bm-badge-warning"> Verbraucht </span>
                    }
                    @default {
                      <span class="bm-badge bm-badge-success"> OK </span>
                    }
                  }
                </div>
              }
              @if (rma.value && rma.value.id && rma.value.id == -1) {
                <div role="alert" class="bm-alert bm-alert-error bm-alert-dash">
                  <span>Nicht gefunden</span>
                </div>
              }
            }
            @if (xidHint) {
              <div role="status" class="bm-alert bm-alert-info bm-alert-soft py-2" data-testid="xid-hint">
                <span>{{ xidHint }}</span>
              </div>
            }
            <div><kbd class="bm-kbd">Enter</kbd> für nächsten Artikel</div>
          </div>
        </fieldset>
      </div>

      <div class="bm-card bm-card-sm">
        <fieldset class="bm-card-body bm-fieldset">
          <legend class="bm-fieldset-legend bm-card-title">Infofeld</legend>
          <textarea class="bm-textarea w-full min-h-32" formControlName="info"></textarea>
          <label class="bm-fieldset-label">Auftragsnummer</label>
          <input class="bm-input w-full" type="text" formControlName="order_number" />
        </fieldset>
      </div>

      <div class="flex flex-row gap-2 justify-end md:col-span-2">
        @if (deliveryNoteId) {
          <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', deliveryNoteId]"> Abbrechen </a>
        } @else {
          <a class="bm-btn bm-btn-ghost" [routerLink]="['/', 'lieferscheine', 'suche', 'index']"> Abbrechen </a>
        }
        <button
          class="bm-btn bm-btn-primary bm-tooltip"
          data-tip="Speichern und Lieferschein ausdrucken"
          [disabled]="!isLoaded || deliveryNoteForm.invalid || submittingNote"
          type="submit"
        >
          Speichern
        </button>
      </div>
    </form>
  </div>
}
